import { render, staticRenderFns } from "./FormFrame.vue?vue&type=template&id=94bab56c&scoped=true&"
import script from "./FormFrame.vue?vue&type=script&lang=js&"
export * from "./FormFrame.vue?vue&type=script&lang=js&"
import style0 from "./FormFrame.vue?vue&type=style&index=0&id=94bab56c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bab56c",
  null
  
)

export default component.exports